export default __webpack_public_path__ + "static/media/logo-vertical.cd9c5c9d.svg";